import {useEffect, useState} from "react";
import {swallowException} from "../utils/appUtils";

export const useFetchItems = <ItemType>(
    companyId: string | null,
    fetchFunction: (companyId: string) => Promise<ItemType[]>,
) => {
    const [items, setItems] = useState<ItemType[]>([]);
    const [counter, setCounter] = useState(0);
    const [isLoading, setIsLoading] = useState(true);

    // https://react.dev/reference/react/useEffect#fetching-data-with-effects
    useEffect(() => {
        let ignore = false;
        setItems([]);
        if (companyId) {
            setIsLoading(true);
            fetchFunction(companyId)
                .then((items) => {
                    if (!ignore) {
                        setItems(items);
                        setIsLoading(false);
                    }
                })
                .catch(swallowException);
        }
        return () => {
            ignore = true;
        };
        /* eslint-disable react-hooks/exhaustive-deps */
    }, [companyId, counter]);

    const refresh = () => {
        setCounter((count) => count + 1);
    };

    return {items, isLoading, refresh};
};
